module.exports = __webpack_public_path__ + "1touch.1068c179f2d9983c4dd5.svg";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/1touch.svg
// module id = ../../../../../src/fonts/1touch.svg
// module chunks = 3